import DefaultCRUD from '../utils'

const resource = `/permission`;

const { get } = DefaultCRUD(resource)

export default {
  get,
}
